import { CommandBarButton, SelectionMode, ShimmeredDetailsList, Stack, Text } from '@fluentui/react';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import GeneralConfig from '../../../config';
import { EventType } from '../../../props/events';

type EventListProps = {
  children?: React.ReactNode;
  events: EventType[];
  loaded: boolean;
  onDeleteItem: (event: EventType) => Promise<void>;
  onUpdateItem: (event: EventType) => void;
};

const EventList: React.FC<EventListProps> = (props) => {
  const events = props.events;
  const [loaded, setLoaded] = useState<boolean>(props.loaded);

  useEffect(() => {
    setLoaded(props.loaded);
    return () => {};
  }, [props.loaded]);

  return (
    <ShimmeredDetailsList
      selectionMode={SelectionMode.none}
      items={events}
      enableShimmer={!loaded}
      columns={[
        {
          key: 'no',
          name: 'No',
          maxWidth: 20,
          minWidth: 20,
          isMultiline: true,
          onRender: (item: EventType, ix) => (
            <Stack horizontal styles={{ root: { width: '100%' } }} verticalAlign='center'>
              <Text>{(ix || 0) + 1}</Text>
            </Stack>
          ),
        },
        {
          key: 'logo',
          name: 'Logo',
          maxWidth: 300,
          minWidth: 300,
          isMultiline: true,
          onRender: (item: EventType, ix: any) => (
            <Stack
              horizontal
              styles={{ root: { width: '100%' } }}
              verticalAlign='center'
              tokens={{ childrenGap: 10 }}
              wrap
            >
              {item.logos.map((i) => (
                <img
                  key={i.id}
                  src={GeneralConfig.assetsHostname + '/' + i.url}
                  style={{ height: 60, width: 60 }}
                />
              ))}
            </Stack>
          ),
        },
        {
          key: 'name',
          name: 'Name',
          maxWidth: 200,
          minWidth: 200,
          isMultiline: true,
          onRender: (item: EventType) => (
            <Stack
              horizontal
              styles={{ root: { width: '100%' } }}
              verticalAlign='center'
              horizontalAlign='space-between'
            >
              <Link to={`/events/${item.code}`}>{item.name}</Link>
              <CommandBarButton
                menuProps={{
                  items: [
                    {
                      key: 'update',
                      text: 'Update',
                      iconProps: { iconName: 'SingleColumnEdit' },
                      onClick: () => {
                        props.onUpdateItem(item);
                      },
                    },
                    {
                      key: 'delete',
                      text: 'Delete',
                      iconProps: { iconName: 'Delete' },
                      onClick: () => {
                        props.onDeleteItem(item);
                      },
                    },
                  ],
                }}
              />
            </Stack>
          ),
        },
        {
          key: 'code',
          name: 'Kode',
          maxWidth: 200,
          minWidth: 200,
          isMultiline: true,
          onRender: (item: EventType) => (
            <Stack
              horizontal
              styles={{ root: { width: '100%' } }}
              verticalAlign='center'
              horizontalAlign='space-between'
            >
              <Text>{item.code}</Text>
            </Stack>
          ),
        },
        {
          key: 'date',
          name: 'Tanggal',
          maxWidth: 200,
          minWidth: 200,
          isMultiline: true,
          onRender: (item: EventType) => (
            <Stack
              horizontal
              styles={{ root: { width: '100%' } }}
              verticalAlign='center'
              horizontalAlign='space-between'
            >
              <Text>{moment(item.date).format('DD/MM/YYYY')}</Text>
            </Stack>
          ),
        },
      ]}
    />
  );
};

export default EventList;
